<template>
  <Modal
    v-model="_value"
    width="900"
    title="设置权限"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Row>
      <div>
        <label>当前角色ID：{{roleInfo.id}} 角色名：{{roleInfo.name}} 昵称：{{roleInfo.nickName}}</label>
      </div>
    </Row>
    <Row style="margin-top: 10px;">
      <Transfer
        :titles="titles"
        :data="allPermissions"
        :target-keys="ownPermissions"
        :list-style="listStyle"
        :render-format="transferRender"
        @on-change="onChange"></Transfer>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'SetPermissionModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        titles:['系统权限', '拥有权限'],
        ownPermissions:[],
        allPermissions:[],
        listStyle:{
          width: '400px'
        },
        roleId: null,
        roleInfo: {
          id:null,
          name:null,
          nickName:null,
          permissions:[]
        }
      }
    },
    methods: {
      ...mapActions([
        'RoleServ_SetPermissions',
        'PermissionServ_GetAll',
        'UserServ_GetDetail'
      ]),
      onChange(newTargetKeys, direction, moveKeys){
        this.ownPermissions = newTargetKeys;
      },
      transferRender(item){
        return item.moduleName + '-' + item.nickName;
      },
      onOk() {
        let permissions = [];
        permissions = this.ownPermissions.map(item => {return parseInt(item)})
        store.dispatch('RoleServ_SetPermissions', {params: {roleId: this.roleId, permissionIds: permissions}}).then(() => {
          this.$Message.success('设置成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if (val) {
          let roleId = this._initValue
          if (roleId) {
            this.roleId = roleId
            store.dispatch('PermissionServ_GetAll', {params: null, urlparams: {sort:genSortParam('moduleName', true)}}).then(() => {
              store.dispatch('RoleServ_GetDetail', {
                params: {id: roleId}
              }).then(() => {
                this.roleInfo = store.getters.get_Role_GetDetailResult
                this.allPermissions = []
                this.ownPermissions = []
                this.roleInfo.permissions.forEach((item, index) => {
                  this.ownPermissions.push(item.id.toString())
                })
                store.getters.get_Permission_GetAllResult.forEach((item, index) => {
                  Vue.set(item, 'key', item.id.toString())
                  this.allPermissions.push(item)
                })
              }).catch(err => {
                this.$Message.error(err)
              })
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
